import Rete from 'rete'

import nodeInput from './Input'
import nodeSelect from './Select'
import nodeControl from './Control'

const numSocket = new Rete.Socket('number')
const boolSocket = new Rete.Socket('boolean')

const sockets = {
  number: numSocket,
  boolean: boolSocket,
}

class InputControl extends Rete.Control {
  constructor(emitter, ikey, type, readonly) {
    super(ikey)
    this.component = nodeInput
    this.props = { emitter, ikey, type, readonly }
  }

  setValue(val) {
    this.vueContext.value = val
    this.vueContext.preview = true
  }
}

class SelectControl extends Rete.Control {
  constructor(emitter, ikey, readonly, options, handle) {
    super(ikey)
    this.component = nodeSelect
    this.props = { emitter, ikey, readonly, options, handle }
  }

  setValue(val) {
    const option = this.vueContext.options.find((item) => item.value === val)
    if (option) {
      this.vueContext.write(option)
    }
  }
}

class Control extends Rete.Control {
  constructor(emitter, createSocket, removeSocket, readonly) {
    super('Control')
    this.component = nodeControl
    this.props = { emitter, createSocket, removeSocket, readonly }
  }
}

// GetTag componenet
export class GetTagComponent extends Rete.Component {
  constructor(readonly, options, boolOptions) {
    super('GET_R')
    this.readonly = readonly
    this.options = options
    this.boolOptions = boolOptions
  }

  builder(node) {
    const editor = this.editor
    const boolOptions = this.boolOptions
    const nOut = new Rete.Output('out1', 'Value', numSocket)
    const bOut = new Rete.Output('out1', 'Value', boolSocket)

    if ('uid' in node.data) {
      const isBool = boolOptions.includes(node.data.uid)
      if (isBool) {
        node.addOutput(bOut)
      } else {
        node.addOutput(nOut)
      }
    }

    function handleSocket(option) {
      if (option) {
        let type = 'number'
        const isBool = boolOptions.includes(option.value)
        if (isBool) {
          type = 'boolean'
        }

        const output = node.outputs.get('out1')
        if (output === undefined || (output && output.socket.name !== type)) {
          if (output) {
            // remove connections
            const connections = []
            for (const index in output.connections) {
              const connection = output.connections[index]
              connections.push(connection)
            }
            connections.map((connection) => editor.removeConnection(connection))

            // remove output
            node.removeOutput(output)
          }

          // add output
          switch (type) {
            case 'number':
              node.addOutput(nOut)
              break
            case 'boolean':
              node.addOutput(bOut)
              break
          }
          // update node
          node.update()
        }
      }
    }

    node.addControl(
      new SelectControl(
        this.editor,
        'uid',
        this.readonly,
        this.options,
        handleSocket
      )
    )
  }
}

// SetTag component
export class SetTagComponent extends Rete.Component {
  constructor(readonly, options, boolOptions) {
    super('SET_R')
    this.readonly = readonly
    this.options = options
    this.boolOptions = boolOptions
  }

  builder(node) {
    const editor = this.editor
    const boolOptions = this.boolOptions
    const nInp = new Rete.Input('in1', 'Value', numSocket)
    const bInp = new Rete.Input('in1', 'Value', boolSocket, true)

    if (this.readonly) {
      nInp.addControl(new InputControl(this.editor, 'in1', 'text', true))
      bInp.addControl(new InputControl(this.editor, 'in1', 'text', true))
    }

    if ('uid' in node.data) {
      const isBool = boolOptions.includes(node.data.uid)
      if (isBool) {
        node.addInput(bInp)
      } else {
        node.addInput(nInp)
      }
    }

    function handleSocket(option) {
      if (option) {
        let type = 'number'
        const isBool = boolOptions.includes(option.value)
        if (isBool) {
          type = 'boolean'
        }

        const input = node.inputs.get('in1')
        if (input === undefined || (input && input.socket.name !== type)) {
          if (input) {
            // remove connections
            const connections = []
            for (const index in input.connections) {
              const connection = input.connections[index]
              connections.push(connection)
            }
            connections.map((connection) => editor.removeConnection(connection))

            // remove input
            node.removeInput(input)
          }

          // add input
          switch (type) {
            case 'number':
              node.addInput(nInp)
              break
            case 'boolean':
              node.addInput(bInp)
              break
          }
          // update node
          node.update()
        }
      }
    }

    node.addControl(
      new SelectControl(
        this.editor,
        'uid',
        this.readonly,
        this.options,
        handleSocket
      )
    )
  }
}

// Math componenet
export class MathComponent extends Rete.Component {
  constructor(name, readonly) {
    super(name)

    this.readonly = readonly
  }

  builder(node) {
    const enable = new Rete.Input('enable', 'Enable', boolSocket, true)
    const inp1 = new Rete.Input('in1', 'IN 1', numSocket)
    const inp2 = new Rete.Input('in2', 'IN 2', numSocket)
    const out = new Rete.Output('out1', 'Result', numSocket)

    inp1.addControl(
      new InputControl(this.editor, 'in1', 'number', this.readonly)
    )
    inp2.addControl(
      new InputControl(this.editor, 'in2', 'number', this.readonly)
    )

    node.addInput(enable)
    node.addInput(inp1)
    node.addInput(inp2)
    node.addOutput(out)
  }
}

// Compare componenet
export class CompareComponent extends Rete.Component {
  constructor(name, readonly) {
    super(name)

    this.readonly = readonly
  }

  builder(node) {
    const enable = new Rete.Input('enable', 'Enable', boolSocket, true)
    const inp1 = new Rete.Input('in1', 'IN 1', numSocket)
    const inp2 = new Rete.Input('in2', 'IN 2', numSocket)
    const out = new Rete.Output('out1', 'Result', boolSocket)

    inp1.addControl(
      new InputControl(this.editor, 'in1', 'number', this.readonly)
    )
    inp2.addControl(
      new InputControl(this.editor, 'in2', 'number', this.readonly)
    )

    node.addInput(enable)
    node.addInput(inp1)
    node.addInput(inp2)
    node.addOutput(out)
  }
}

// AlarmComponent component
export class AlarmComponent extends Rete.Component {
  constructor() {
    super('ALARM')
  }

  builder(node) {
    const inp1 = new Rete.Input('in1', 'Value', boolSocket, true)

    node.addControl(new InputControl(this.editor, 'preview', 'text', true))
    node.addInput(inp1)
  }
}

// IoComponent component
export class IoComponent extends Rete.Component {
  constructor(name, io, readonly) {
    super(name)

    this.io = io
    this.readonly = readonly
  }

  builder(node) {
    const editor = this.editor
    const key = node.name === 'INPUTS' ? 'outputs' : 'inputs'

    function createSocket(title, type, ikey) {
      let create = true

      node[key].forEach((item) => {
        if (item.name.toLowerCase() === title.toLowerCase()) {
          create = false
        }
      })

      if (create) {
        if (!ikey) {
          const skey = key === 'inputs' ? 'out' : 'in'
          ikey = `${skey}1`

          if (node[key].size) {
            let lsKey = Array.from(node[key])[node[key].size - 1][0]
            lsKey = lsKey.replace(skey, '')
            ikey = `${skey}${parseInt(lsKey) + 1}`
          }
        }

        const multi = type === 'boolean'

        switch (key) {
          case 'inputs':
            node.addInput(new Rete.Input(ikey, title, sockets[type], multi))
            break
          default:
            node.addOutput(new Rete.Output(ikey, title, sockets[type]))
            break
        }

        node.update()
      }
    }

    function removeSocket(title) {
      let socket

      node[key].forEach((item) => {
        if (item.name.toLowerCase() === title.toLowerCase()) {
          socket = item
        }
      })

      if (socket) {
        // remove connection
        const connections = []
        for (const index in socket.connections) {
          const connection = socket.connections[index]
          connections.push(connection)
        }
        connections.map((connection) => editor.removeConnection(connection))

        switch (key) {
          case 'inputs':
            node.removeInput(socket)
            break
          default:
            node.removeOutput(socket)
            break
        }

        node.update()
      }
    }

    node.addControl(
      new Control(this.editor, createSocket, removeSocket, this.readonly)
    )

    for (const key in this.io) {
      const input = this.io[key]
      createSocket(input.name, input.type, key)
    }
  }
}

// FunctionComponent component
export class FunctionComponent extends Rete.Component {
  constructor(name, title, io, readonly) {
    super(name)

    this.title = title
    this.io = io
    this.readonly = readonly
  }

  builder(node) {
    const editor = this.editor
    const readonly = this.readonly
    const enable = new Rete.Input('enable', 'Enable', boolSocket, true)
    node.addInput(enable)

    let key = 'inputs'

    function createSocket(name, type, ikey) {
      const multi = type === 'boolean'
      let socket

      switch (key) {
        case 'inputs':
          socket = new Rete.Input(ikey, name, sockets[type], multi)
          if (type === 'number') {
            socket.addControl(new InputControl(editor, ikey, type, readonly))
          }
          node.addInput(socket)
          break
        default:
          socket = new Rete.Output(ikey, name, sockets[type])
          node.addOutput(socket)
          break
      }

      node.update()
    }

    // Add input
    for (const key in this.io.inputs) {
      const item = this.io.inputs[key]
      createSocket(item.name, item.type, key)
    }

    // Add output
    key = 'outputs'
    for (const key in this.io.outputs) {
      const item = this.io.outputs[key]
      createSocket(item.name, item.type, key)
    }
  }
}
